import {
	type FrontendPlacementMessage,
	type FrontendStage,
} from '@post-office/message-maker-browser/types';

import { noValidation } from '@post-office/message-maker-browser/message-helpers';

import {
	PlacementFrontend,
	type PlacementRenderProps,
} from '@post-office/browser--townsquare/goal-page-banners-placement';

import { type MessageTemplateContext } from '../../..';

import { SuccessMeasuresChangeboardingBanner } from './SuccessMeasuresChangeboardingBanner';

import type { CreatePlacementMessageConfig } from '@post-office/message-template-contracts/placement-v2';

type RenderProps = MessageTemplateContext & PlacementRenderProps;

// This is the Message Frontend. In this Placement we have render.Component which takes a React Component which will render your message in the Placement.
export const MessageFrontend: (config: CreatePlacementMessageConfig) => FrontendPlacementMessage<{
	render: FrontendStage<PlacementRenderProps>;
}> = PlacementFrontend.createMessageFrontend({
	render: {
		validate: noValidation<RenderProps>(),
		Component: ({ isGoalsOnlyUser, dismiss }: RenderProps) => {
			return (
				<SuccessMeasuresChangeboardingBanner isGoalsOnlyUser={isGoalsOnlyUser} dismiss={dismiss} />
			);
		},
	},
});
